import { AuthActionType } from './actions';
export const defaultAuthState = { token: '' };
export function authReducers(state = defaultAuthState, action) {
    const { type } = action;
    switch (type) {
        case AuthActionType.Clear:
            return Object.assign({}, defaultAuthState);
        case AuthActionType.Update:
            return {
                token: action.data
            };
        default:
            return state;
    }
}
